// extracted by mini-css-extract-plugin
export default {"header":"commonLayout_header__aC+ak","MenuDrawer_container":"commonLayout_MenuDrawer_container__hRzYm","profile_container":"commonLayout_profile_container__zZlsy"};